import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'

import WorkProfiles from './../ProfessionalWorkProfiles/components/WorkProfiles/Index'
import DeleteAccount from '@/components/Account/components/DeleteAccount/Index'

import { VueEditor } from  'vue2-editor'

export default {
    name: 'ProfessionalRegister',
    computed,
    data,
    methods,
    mounted,
    components: {
        WorkProfiles,
        DeleteAccount,
        VueEditor
    }
}
